import React from "react";
import CategoryPage from "./CategoryPage";

export default function PumpsPage() {
  return (
    <CategoryPage
      categoryMatch="pumps"
      exact={true}
      title="Pumps"
      subtitle="Industrial, submersible, and process pumps for mining, water, and industrial applications."
      searchPlaceholder="Search pumps..."
    />
  );
}